function isFocusableCandidate(el: Element): boolean {
  if (el.getAttribute('tabindex') === '-1') {
    return false;
  }
  if (el.closest('[aria-hidden="true"]')) {
    return false;
  }
  const style = globalThis.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') {
    return false;
  }
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

/**
 * Focus first visible link or form control inside #main-content, or the main landmark.
 */
export function skipToMainContent(): void {
  const mainEl = document.getElementById('main-content');
  if (!mainEl) {
    return;
  }

  const selector = [
    'a[href]:not([href=""]):not([href="#"])',
    'button:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'textarea:not([disabled])',
    'select:not([disabled])',
  ].join(', ');

  const nodes = Array.from(mainEl.querySelectorAll(selector));
  const focusable = nodes.find((el) => isFocusableCandidate(el)) as HTMLElement | undefined;
  if (focusable) {
    focusable.focus();
    focusable.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  mainEl.focus();
  mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
